import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].GET_BRIGADES]: {
		url:'/company/:companyId/machines/:machineId/brigade/',
	},
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].GET_BRIGADE]: {
		url: '/company/:companyId/machines/:machineId/brigade/:brigadeId/',
	},
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].CREATE_BRIGADE]: {
		url:'/company/:companyId/machines/:machineId/brigade/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].PATCH_BRIGADE]: {
		url: '/company/:companyId/machines/:machineId/brigade/:brigadeId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].PUT_BRIGADE]: {
		url: '/company/:companyId/machines/:machineId/brigade/:brigadeId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].DELETE_BRIGADE]: {
		url: '/company/:companyId/machines/:machineId/brigade/:brigadeId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}